export enum RecipeType {
  RECIPE,
  GUIDES,
  PURCHASE_LINK
}
